var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"4.24.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const ignoredMessages = ['Navigation cancelled by native app'];

Sentry.init({
  dsn: 'https://5c29064ebb6746f7a3fbdc98073f28d7@o1260081.ingest.sentry.io/6437906',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: publicRuntimeConfig.sentryTraceSampleRate || 0,
  // Sample rate on errors
  sampleRate: publicRuntimeConfig.sentryErrorSampleRate || 0,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT || 'unknown',

  integrations: [
    new Sentry.BrowserTracing({
      // custom options
    }),
    new Sentry.BrowserProfilingIntegration(),
  ],

  initialScope: (scope) => {
    return scope;
  },

  beforeSend(event, hint) {
    const error = hint?.originalException;
    const message =
      typeof error === 'string' ? error : error?.message || event.message;

    if (
      typeof message === 'string' &&
      ignoredMessages.some((ignored) => message.includes(ignored))
    ) {
      return null;
    }

    return event;
  },
});
